export default {
  'wpov.title.continued.running': {
    ko: '지속 실행 중인 목록',
    ja: '連続実行中のリスト',
    en: 'Continued Running List',
  },
  'wpov.field.wp.bname': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
  },
  'wpov.field.wp.report': {
    ko: 'Report',
    ja: 'レポート',
    en: 'Report',
  },
  'wpov.field.wp.status': {
    ko: 'Status',
    ja: '状況',
    en: 'Status',
  },
  // BEGIN::Added.by.KWShin.2026.03.31.
  'workprcs.type.0': {
    ko: 'NOWP',
    en: 'NOWP',
    cn: 'NOWP',
    ja: 'NOWP',
  },
  'workprcs.type.1': {
    ko: 'DIA',
    ja: 'DIA',
    en: 'DIA',
  },
  'workprcs.type.2': {
    ko: 'UPD',
    ja: 'UPD',
    en: 'UPD',
  },
  'workprcs.type.3': {
    ko: 'ENQ',
    ja: 'ENQ',
    en: 'ENQ',
  },
  'workprcs.type.4': {
    ko: 'BGD',
    ja: 'BGD',
    en: 'BGD',
  },
  'workprcs.type.5': {
    ko: 'SPO',
    ja: 'SPO',
    en: 'SPO',
  },
  'workprcs.type.6': {
    ko: 'UP2',
    ja: 'UP2',
    en: 'UP2',
  },
  // FINISH::Added.by.KWShin.2026.03.31.
  'wpov.field.wp.pid': {
    ko: 'PID.',
    ja: 'PID.',
    en: 'PID.',
  },
  'wpov.field.wp.typ': {
    ko: 'Type',
    ja: 'タイプ',
    en: 'Type',
  },
  'wpov.refresh.cycle': {
    ko: '갱신 주기',
    ja: '更新間隔',
    en: 'Refresh cycle',
  },
  'wpov.title.running': {
    ko: '실행 중인 목록',
    ja: '実行中のリスト',
    en: 'Running List',
  },
  'workprcs.status.2': {
    ko: '대기중',
    ja: '待機中',
    en: 'Waiting',
  },
  'workprcs.status.4': {
    ko: '실행중',
    ja: '実行中',
    en: 'Running',
  },
  'workprcs.status.8': {
    ko: '보류됨',
    ja: '保留',
    en: 'On Hold',
  },
  'workprcs.status.16': {
    ko: '중지됨',
    ja: '停止',
    en: 'Stopped',
  },
  'workprcs.status.32': {
    ko: '다운됨',
    ja: 'シャットダウン',
    en: 'Shutdow',
  },
  'workprcs.status.64': {
    ko: 'reserv.',
    ja: '予約',
    en: 'reserv.',
  },
  'workprcs.status.128': {
    ko: '시작됨',
    ja: '開始',
    en: 'Started',
  },
  'wpov.field.wp.mem': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'wpov.field.wp.mandt': {
    ko: 'Client',
    ja: 'クライアント',
    en: 'Client',
  },
  'wpov.title.done': {
    ko: '오래 실행된 목록',
    ja: '長時間実行されたリスト',
    en: 'Done with Long Time',
  },
  'wpov.field.inst.short.alias': {
    ko: 'AP',
    ja: 'AP',
    en: 'AP',
  },
  'wpov.field.wp.no': {
    ko: 'No.',
    ja: 'No.',
    en: 'No.',
  },
  'wpov.field.running.duration': {
    ko: 'Elapsed time',
    ja: '経過時間',
    en: 'Elapsed time',
  },
  'wpov.reset': {
    ko: '변경 사항 적용',
    ja: '変更事項を適用',
    en: 'Apply updated',
  },
  'wpov.field.wp.table': {
    ko: 'Table',
    ja: 'テーブル',
    en: 'Table',
  },
  'wpov.field.wp.action': {
    ko: 'Action',
    ja: 'アクション',
    en: 'Action',
  },
  'wpov.rspn.time': {
    ko: '응답시간 (s)',
    ja: '応答時間(s)',
    en: 'Response time (s)',
  },
  'wpov.field.wp.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
};
